import React from 'react';
import cx from 'classnames';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'hooks/store';
import { AppPageSelector, PlatformIframeViewEnabledSelector, setPage } from 'store/common';
import { Pages } from 'constants/pages';
import { useAllowedMenuItems } from 'components/Sidebar/constants';

import CompanyPolicies from 'components/CompanyPolicies';
import HelpMenu from 'components/HelpMenu';
import ThemeSwitch from 'components/Sidebar/components/ThemeSwitch';
import { ReactComponent as LogOutIcon } from 'assets/icons/logout.svg';

import { signOut } from 'utils/session';
import { LOGIN } from 'router/routes';

import useStyles from './styles';

const SlimNavigation: React.FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentPage = useAppSelector(AppPageSelector);
  const platformIframeViewEnabled = useAppSelector(PlatformIframeViewEnabledSelector);
  const menuItems = useAllowedMenuItems();

  const handleClick = (page: Pages): void => {
    dispatch(setPage(page));
  };

  const handleLogout = (): void => {
    signOut();
    navigate(LOGIN);
  };

  return (
    <div className={classes.slimNavBar}>
      <div className={classes.slimNavTabs}>
        {menuItems.map(item => (
          <Tooltip title={item.text} placement="right" key={item.text}>
            <div
              className={cx(classes.slimNavItem, {
                [classes.slimNavItemActive]: currentPage === item.page,
              })}
              onClick={() => { handleClick(item.page); }}
            >
              <span className={classes.slimNavIcon}>{item.icon}</span>
            </div>
          </Tooltip>
        ))}
      </div>

      <div className={classes.slimNavActions}>
        <ThemeSwitch />
        <div className={classes.slimNavActionButton}>
          <CompanyPolicies />
        </div>
        <div className={classes.slimNavActionButton}>
          <HelpMenu />
        </div>
        {!platformIframeViewEnabled && (
          <Tooltip title="Log out" placement="right">
            <div className={classes.slimNavActionButton} onClick={handleLogout}>
              <LogOutIcon />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default SlimNavigation;
